const state = {
  activeRequests: 0
}

const mutations = {
  incrementRequests (state) {
    state.count = state.activeRequests++
  },
  decrementRequests (state) {
    if (state.activeRequests > 0) { state.count = state.activeRequests-- }
  }
}

const getters = {
  activeRequests: state => state.activeRequests > 0
}

export const counterRequests = {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/counter.requests.module.js